export default "__VITE_ASSET__A$UeNiU4__"